import React from "react";

import size from "lodash/size";
import pull from "lodash/pull";
import join from "lodash/join";
import forEach from "lodash/forEach";
import indexOf from "lodash/indexOf";
import List from "@material-ui/core/List";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import ListItem from "@material-ui/core/ListItem";
import TextField from "@material-ui/core/TextField";
import DialogTitle from "@material-ui/core/DialogTitle";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

class MultiSelectField extends React.Component {
  state = {
    open: false,
    tempValue: [],
  };

  handleCheck = (e, val) => {
    e.preventDefault();

    // const { tempValue } = this.state;
    const { field, form } = this.props;

    let _temp = field.value;

    if (indexOf(field.value, val) > -1) {
      _temp = pull(field.value, val);
    } else {
      _temp.push(val);
    }

    form.setFieldValue(field.name, _temp);

    /* this.setState({
      tempValue: _temp,
    }); */
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  saveForm = () => {
    const { form, field } = this.props;

    const v = { ...this.state };

    form.setFieldValue(field.name, v.tempValue);

    this.handleClose();
  };

  render() {
    const { form, field, options } = this.props;
    const { open, tempValue } = this.state;

    //const classes = useStyles();

    let otherProps = {};

    if (form.errors[field.name] && form.touched[field.name]) {
      otherProps.helperText = form.errors[field.name];
      otherProps.error = true;
    }

    const renderValue = () => {
      const labels = [];

      forEach(options, (val) => {
        if (indexOf(field.value, val.value) > -1) {
          labels.push(val.name);
        }
      });

      return join(labels, ", ");
    };

    return (
      <React.Fragment>
        <TextField
          variant="outlined"
          {...this.props}
          value={renderValue()}
          {...otherProps}
          onClick={this.handleClickOpen}
          InputProps={{
            readOnly: true,
          }}
          InputLabelProps={{
            shrink: size(field.value) > 0 ? true : false,
          }}
          style={{ marginTop: 10, width: "100%" }}
        />

        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle>Select States</DialogTitle>
          <DialogContent>
            <List>
              {options.map((val, key) => {
                return (
                  <ListItem key={val.value}>
                    <ListItemIcon>
                      <Checkbox
                        key={key}
                        edge="start"
                        tabIndex={-1}
                        disableRipple
                        onClick={(e) => {
                          this.handleCheck(e, val.value);
                        }}
                        checked={indexOf(field.value, val.value) !== -1}
                      />
                    </ListItemIcon>
                    <ListItemText primary={val.name} />
                  </ListItem>
                );
              })}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default MultiSelectField;



// WEBPACK FOOTER //
// ./src/components/MultiSelectField.js